<template>
  <el-dialog
    title="挂断电话"
    :show-close="false"
    :visible.sync="psVisible"
    :close-on-click-modal="false"
    center
  >
    <el-radio-group v-model="radio" @change="dialog" class="phradio">
      <div class="block">
        <div class="radioChoose"><el-radio :label="2">预约访问</el-radio></div>
        <div v-if="radio == 2" class="zoneTime">
          <label class="zhonelabel">
            <span class="lableText">约访时间 :</span>
            <el-date-picker
              value-format="yyyy/MM/dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              v-model="phoneObj.tiemDate"
              @change="timedate"
              type="datetime"
              placeholder="选择日期时间"
              class="demonstration"
            ></el-date-picker>
          </label>
          <label class="zhonelabel" style="margin-left: 20px">
            <span class="lableText">电话区号 :</span>
            <el-input
              v-model="phoneObj.zone"
              placeholder="请填写区号"
            ></el-input>
          </label>
        </div>
        <div v-if="radio == 2" class="zoneTime">
          <label class="zhonelabel">
            <span class="lableText">电话号码 :</span>
            <el-input
              v-model="phoneObj.phone"
              placeholder="请填写电话号码"
            ></el-input>
          </label>
          <label class="zhonelabel" style="margin-left: 20px">
            <span class="lableText">分机号码 :</span>
            <el-input
              v-model="phoneObj.Ext"
              placeholder="请填写分机号码"
            ></el-input>
          </label>
        </div>
        <div v-if="radio == 2" class="zoneTime">
          <label class="zhonelabel">
            <span class="lableText">备注&emsp;&emsp; :</span>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="phoneObj.phoneRemark"
            ></el-input>
          </label>
        </div>
      </div>
      <div class="radioData" v-for="item in radiodata" :key="item.id">
        <el-radio v-if="item.isId != 1 && item.isId != 2" :label="item.isId">{{
          item.isState
        }}</el-radio>
        <p v-if="item.isId != 1 && item.isId != 2" class="dataTitle">
          {{ item.isDesc }}
        </p>
      </div>
    </el-radio-group>
    <span slot="footer" class="dialog-footer"
      ><el-button type="primary" @click="phoneOk">确 定</el-button></span
    >
  </el-dialog>
</template>

<script>
export default {
  name: "phoneStatus",
  data() {
    return {
      // 约访电话对象
      phoneObj: {
        tiemDate: "", //日期时间
        zone: "", //区
        phone: "", //手机
        Ext: "", //分机
        phoneRemark: "", //备注
      },
      psVisible: false,
      psData: [],
      radio: 1, //状态
      radiodata: [], //状态列表
    };
  },
  mounted() {
    // this.loadData();
  },
  methods: {
    timedate(value) {
      console.log(value);
      console.log(this.phoneObj.tiemDate);
    },
    // 确定
    phoneOk() {
      if (this.radio == 1) {
        this.$message.error("请选择样本信息");
        return false;
      }
      if (this.radio == 2) {
        if (this.phoneObj.tiemDate == "") {
          this.$message.error("约访时间不能为空");
          return false;
        }
      }

      let params = {
        ssId: samplesatate,
        phoneObj: this.phoneObj,
        is_Id: this.radio,
      };
      console.log(params);
      this.$emit("ok", params);
    },
    // 选择样本状态
    dialog(value) {
      console.log(value);
      this.radiodata.forEach((item) => {
        if (value == item.isId) {
          samplesatate = item.ssId;
        }
      });
    },
    openPhoneSt() {
      this.loadData();
    },
    loadData() {
      let that = this;
      let params = {
        that: this,
        method: "GET",
        url: `${this.$config.service.queryPageList}?prCode=${this.$store.state.pr_Code}&pagesize=100&pageIndex=1`,
        data: {
          // prCode: this.$store.state.pr_Code,
          // pagesize: 100,
          // pageIndex: 0
        },
        cb(res) {
          if (res.result == "111111111111") {
            that.radio = 1;
            that.radiodata = res.data;
            console.log(res.data);
            that.psVisible = true;
          } else {
            that.$message.error(res.msg);
          }
        },
      };
      this.$util.request(params);
    },
  },
};
</script>
<style type="text/css" lang="scss" scoped="scoped">
.phradio {
  width: 100%;
  max-height: 600px;
  padding-right: 20px;
  overflow: auto;
  /deep/.el-radio {
    line-height: 40px;
  }
  .block {
    border-bottom: 1px solid #cccccc;
    .radioChoose {
      width: 100%;
    }
    .zoneTime {
      display: flex;
      justify-content: space-between;
      padding: 5px 0px;
      line-height: 40px;
      .zhonelabel {
        font-size: 14px;
        /deep/.el-input {
          width: auto;
        }
        /deep/.el-textarea {
          width: auto;
        }
        .lableText {
          width: 80px;
        }
      }
    }
  }
  .radioData {
    width: 100%;
    // padding: 10px 0px;

    .dataTitle {
      // height: 20px;
      color: indianred;
      font-size: 16px;
    }
  }
}
</style>
